const limits = {street:160, street2:120, city:90, state:65, postalCode:20};
export function validateBusinessAddress(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    throw new Error('Please enter your business address.');
  }
  const result = {};
  for (const [key, max] of Object.entries(limits)) {
    if (data[key] != null && typeof data[key] !== 'string') throw new Error('Business address contains invalid information.');
    result[key] = String(data[key] || '').trim();
    if (result[key].length > max) throw new Error(`The ${key} field is too long.`);
  }
  if (result.street.length < 3 || result.city.length < 2 || result.state.length < 2 || result.postalCode.length < 3) {
    throw new Error('Street, city, state, and postal code are required.');
  }
  return result;
}
